import React from "react";

import Header from "../partials/Header";
import Footer from "../partials/Footer";
import CTA from "../partials/CTA";

function Rules() {
  return (
    <div className="flex flex-col min-h-screen overflow-hidden">
      {/*  Site header */}
      <Header />

      {/*  Page content */}
      <main className="flex-grow">
        <section className="relative">
          <div className="pt-32 pb-12 md:pt-40 md:pb-20 mx-4">
            <article className="prose mx-auto">
              <h1>
                <span className="bg-clip-text text-transparent bg-gradient-to-r from-blue-500 to-teal-400">
                  Dragon Rush
                </span>{" "}
                Rules
              </h1>
              <p>
                Dragon Rush is an event hosted by ScholarsMC, where teams of up
                to 4 battle against each other to be the first to kill the Ender
                Dragon.
              </p>
              <p>
                The Dragon Rush 8 date and time will be announced. Log into the
                server at <strong>mc.scholarsmc.org</strong> five minutes before
                the event starts to join the group photo!
              </p>
              <p>
                Join us on Discord at{" "}
                <a href="https://discord.gg/D97aSeBgDB">
                  https://discord.gg/D97aSeBgDB
                </a>
              </p>
              <h2>Eligibility</h2>
              <ul>
                <li>
                  Minecraft Java Edition version 1.21.8 is required. This event
                  requires a Minecraft Java Edition account to join. We make no
                  guarantee about compatibility with other versions.
                </li>
                <li>
                  All participating players must be in our Discord server at{" "}
                  <a href="https://discord.gg/D97aSeBgDB">
                    https://discord.gg/D97aSeBgDB
                  </a>
                  , and join the short briefing immediately before the event at
                  the time announced on Discord.
                </li>
                <li>
                  No university or school affiliation is required to
                  participate.
                </li>
              </ul>

              <h2>Event Format</h2>
              <p>This event is limited to 16 teams or 64 participants.</p>
              <p>
                PvP is enabled and encouraged. Use it as a tactic to stop other
                teams from getting to the dragon first!
              </p>
              <p>
                The team with the player that deals the final blow to the Ender
                Dragon is the winning team. This means you should kill anybody
                else in the End before attempting to take on the dragon to
                ensure your team will win!
              </p>
              <p>
                You're able to teleport to teammates once every fifteen minutes.
                The warmup time is 15 seconds for teleports. Use this by typing{" "}
                <code>/tpa playername</code> and waiting for them to type{" "}
                <code>/tpaccept</code>.
              </p>
              <strong>
                Teleportation will be disabled after any team throws an Eye of
                Ender.
              </strong>

              <h2>World & Mechanics</h2>
              <p>
                World Borders: Overworld: 6000x6000, Nether: 4000x4000, End:
                1250x1250.
              </p>
              <p>
                Nether to Overworld Scaling: 1:2 i.e. 1 block traveled in the
                Nether is 2 blocks in the Overworld (changed from Minecraft
                default of 1:8)</p>
              <p>Difficulty: Normal</p>
              <p>
                Upon entering the Nether, you will receive a compass that points
                to the nearest Nether Fortress. Use <code>/compass</code> to get
                a new compass if you lost yours.
              </p>
              <p>
                There will be four Nether Fortresses within +/- 432 blocks of
                the Nether's origin (0, 0), one in each quadrant.
              </p>
              <p>
                Spawners in the Nether will be unbreakable as there are very few
                fortresses.
              </p>
              <p>
                Throwing an Eye of Ender will immediately tell the player who
                threw the Eye of Ender the coordinates of the nearest
                stronghold.
              </p>
              <p>
                Bed and respawn anchor explosions do not damage players or the
                Ender Dragon.
              </p>
              <p>
                No portal trapping! Camping outside nether portals is allowed.
                Spawn-killing / PvP on the End platform is not allowed - as soon
                as the player leaves the platform, PvP is allowed.
              </p>

              <h2>Special Event Ruleset</h2>
              <p>
                Every player gets a potion effect from the list below! No two
                players on the same team may have the same potion effect. The
                person registering your team will select what potion effect you
                get.
              </p>
              <ul>
                <li>Fire Resistance</li>
                <li>Invisibility</li>
                <li>Haste III</li>
                <li>Speed II</li>
              </ul>
              <p>
                Night vision is available to all participants, toggleable with{" "}
                <code>/nv</code>.
              </p>
              <p>
                The world will be in 1.21.8, with modern PvP (i.e. not 1.8
                legacy PvP).
              </p>
              <p>
                Ender pearl drops from piglin trading are NOT boosted and are
                identical to vanilla Minecraft.
              </p>
              <p>
                On death, a portion of your gear is protected. The system works
                as follows:
              </p>
              <ul>
                <li>
                  Armor: You will keep 75% of your equipped armor pieces,
                  rounded down. For a full set, 3 out of 4 pieces will be
                  randomly kept, and 1 will drop.
                </li>
                <li>
                  Tools: The system first identifies your single best tool of
                  each type (sword, axe, pickaxe, shovel). You will then keep
                  75% of those unique tools, rounded down. The remaining tools
                  from this set will drop.
                </li>
                <li>
                  Everything Else: All other items in your inventory, including
                  any duplicate or lower-tier gear, will drop on death as
                  normal.
                </li>
              </ul>
              <p>
                There are unlimited respawns. However, you cannot enter the End
                for one minute on your first death in the End, two minutes on
                your second death, etc, capping at five minutes.
              </p>

              <h2>Event Rules</h2>
              <p>
                Review these rules carefully! If any member of your team breaks
                these rules, your team will be disqualified.
              </p>
              <ol>
                <li>
                  <a href="https://scholarsmc.org/rules">
                    ScholarsMC rules 1, 2, and 5 are in effect.
                  </a>{" "}
                  This means: don't cheat (no minimap mods, x-ray, "hacks", etc)
                  and be nice. If you violate our rules during any of our
                  events, your ban will be unappealable.
                </li>
                <li>
                  Cross-teaming is prohibited. This means you should not work
                  with or communicate with other teams in any way.
                </li>
                <li>
                  Communication is limited to team members only. You should not
                  give or receive information from anybody other than your
                  teammates. While the event may be streamed, participants are
                  prohibited from viewing the stream.
                </li>
              </ol>
              <h2>Entry Fee & Prize</h2>
              <p>
                There is <strong>no entry fee</strong> to participate in Dragon
                Rush.
              </p>
              <p>
                There is <strong>no prize</strong> for winning, other than glory
                and bragging rights!
              </p>
              <p>
                Isaac / ScholarsMC hosts these events for fun and for the love
                of Minecraft. We hope that you enjoy this event as much as we
                enjoy hosting it!
              </p>
            </article>
          </div>
        </section>
        {/*  Page sections */}
        <CTA />
      </main>
      <Footer />
    </div>
  );
}

export default Rules;
